import axios from "axios";
import { Tree } from "primereact/tree";
import React, { useContext, useState } from "react";
import Endpoint from "../endpoints/Endpoint";
import EnumTipovaParametraStatistickogIzvestaja from "../utils/EnumTipovaParametraStatistickogIzvestaja";
import { axiosConfig, useEffectOnce } from "../utils/Utils";
import NewParametri from "./izvestaj/NewParametri";
import { AppContext } from "./Store";
import { useParams } from "react-router-dom";

export default function NewIzvestaji() {
  const { izvestaj } = useParams<{ izvestaj?: string }>();
  const { authData } = useContext(AppContext);
  const [kategorijeIzvestajaTreeData, setKategorijeIzvestajaTreeData] = useState();
  const [displayTabView, setDisplayTabView] = useState(false);
  const [selectOptions, setSelectOptions] = useState({});
  const [parametriStatistickiIzvestaj, setParametriStatistickiIzvestaj] = useState();
  const [statistickiIzvestaj, setStatistickiIzvestaj] = useState();
  const [idKategorijaStatistickogIzvestaja, setIdKategorijaStatistickogIzvestaja] = useState<any>();
  const [paramsUrl, setParamsUrl] = useState<Map<any, any>>();

  const search = window.location.search;
  const params = new URLSearchParams(search);

  useEffectOnce(() => {
    getData();
  });

  const getData = () => {
    axios
      .get(Endpoint.KATEGORIJA_STATISTICKOG_IZVESTAJA_TREE, axiosConfig(authData.token))
      .then((response) => {
        response.data.forEach((kat: any) => {
          kat.children.forEach((tipStatIzv: any) => {
            tipStatIzv.children.forEach((statIzvestaj: any) => {
              statIzvestaj.idKategorijaStatistickiIzvestaj = kat.key;
              if (izvestaj !== undefined && statIzvestaj.jasperFajl.toLowerCase().replace(" ", "_").includes(izvestaj)) {
                openStatistickiIzvestaj(statIzvestaj, true);
                setIdKategorijaStatistickogIzvestaja(statIzvestaj.idKategorijaStatistickiIzvestaj);
              }
            });
            tipStatIzv.key = kat.key + "-" + tipStatIzv.key;
          });
        });
        setKategorijeIzvestajaTreeData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openStatistickiIzvestaj = (izvestaj: any, urlOpened?: boolean) => {
    axios
      .get(
        Endpoint.PARAMETAR_STATISTICKI_IZVESTAJ + "/search/findByAktivanAndStatistickiIzvestaj",
        axiosConfig(authData.token, {
          statistickiIzvestaj: Endpoint.STATISTICKI_IZVESTAJI + "/" + (izvestaj.key ? izvestaj.key : izvestaj.id),
          aktivan: true,
          projection: "getWithRelatedObjects",
        })
      )
      .then((response) => {
        let paramStatIzve = response.data._embedded.parametarStatistickiIzvestajs;
        if (urlOpened !== undefined && urlOpened && paramStatIzve) {
          let paramsObject = new Map();
          params.forEach((value, key) => {
            paramStatIzve.forEach((paramStat: any) => {
              if (paramStat.parametarStatistickiIzvestaj.requestNaziv.toLowerCase() === key.toLocaleLowerCase()) {
                paramsObject.set(key, value);
              }
            });
          });
          setParamsUrl(paramsObject);
        }

        paramStatIzve.forEach((param: any, i: any) => {
          if (param.sifarnikTipovaParametraStatistickogIzvestaja.numerickaVrednost === EnumTipovaParametraStatistickogIzvestaja.SKUPOVNI && param.tipParametraStatistickogIzvestaja.upit !== "") {
            axios
              .get(Endpoint.EXECUTE_QUERY, axiosConfig(authData.token, { query: param.tipParametraStatistickogIzvestaja.upit }))
              .then((response) => {
                var object = response.data;
                var mapa: any = selectOptions;
                let options = object.map((obj: any, o: any) => {
                  let key = obj[0];
                  let naziv = obj[1];
                  let numVrednost = obj[2] ? obj[2] + " - " : "";
                  return { value: key, label: numVrednost + naziv };
                });
                mapa[param.parametarStatistickiIzvestaj.id] = options;
                setSelectOptions(mapa);
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });

        setParametriStatistickiIzvestaj(paramStatIzve);
        setStatistickiIzvestaj(izvestaj);
      })
      .catch((error) => {
        console.log(error);
      });
    setDisplayTabView(true);
  };

  return (
    <div className="layout-report grid">
      <div className="tree-view-report">
        <Tree
          value={kategorijeIzvestajaTreeData}
          selectionMode="single"
          onSelect={(e: any) => {
            if (!e.node.children) {
              setIdKategorijaStatistickogIzvestaja(e.node.idKategorijaStatistickiIzvestaj);
              openStatistickiIzvestaj(e.node);
            }
          }}
        />
      </div>
      {displayTabView && parametriStatistickiIzvestaj && (
        <div className="tree-view-report">
          <NewParametri
            idKategorijaStatistickogIzvestaja={idKategorijaStatistickogIzvestaja}
            skupovniParametri={selectOptions}
            propsParametri={parametriStatistickiIzvestaj}
            statistickiIzvestaj={statistickiIzvestaj}
            openStatistickiIzvestaj={openStatistickiIzvestaj}
            paramsUrl={paramsUrl}
          />
        </div>
      )}
    </div>
  );
}
